module.exports = __webpack_public_path__ + "img/image-collection-sliding-overlays-nissan.b461907b.png";